import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import TableTop from "../../../Components/UI/TableTop";

import { useTableSearch } from "../../../core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import Breadcrumbs from "core/breadcrumbs";
import CpfContributionModal from "Components/Modal/master/CpfContributionModal";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import {
  useDeletePassTypeMutation,
  useGetPassTypeQuery,
  useInsertPassTypeMutation,
  useUpdatePassTypeMutation,
} from "AppQuries/master/PassType/pass-type";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import PassTypeModal from "Components/Modal/master/PassTypeModal";
import { yupResolver } from "@hookform/resolvers/yup";
import { passTypeValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import ToastNotification from "Components/UI/ToastNotification";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import ReportTools from "Components/UI/ReportTools";
import { Popconfirm, Switch } from "antd";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const PassType = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useGetPassTypeQuery({
    companyCode: userData?.companyCode,
    isTrue: showActiveOnly,
  });

  const {mutate: deletePassType} = useDeletePassTypeMutation();

  const methods = useForm({
    resolver: yupResolver(passTypeValidationSchema),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutate: addItem } = useInsertPassTypeMutation();
  const { mutate: updateItem } = useUpdatePassTypeMutation();
  const [selectedItem, setSelectedItem] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ItemData = data?.map((d, _id) => ({
    id: _id + 1,
    ...d,
    dataFields: d.dataFields !== "" ? d.dataFields?.split(",") : [],
  }));

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    console.log(payload, id);
    deletePassType(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("PassType Deleted Successfully.");
          setSelectedItem(null);
          setShow(false);
          GetItems();
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData?.companyCode,
      passCode: 0,
      passName: "",
      haveSkillUnSkillOption: true,
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    console.log(item)
    setSelectedItem(item);
    methods.reset({
      companyCode: item.companyCode,
      passCode: item.passCode,
      passName: item.passName,
      haveSkillUnSkillOption: item.haveSkillUnSkillOption,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      dataFields: item.dataFields,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    console.log(payload);
    if (payload.dataFields.length > 0) {
      payload.dataFields = payload.dataFields.toString();
    }
    if (selectedItem) {
      updateItem(payload, {
        onSuccess: (data) => {
          console.log();
          if (data) {
            toast.success("Pass Type Updated Successfully.");
            setSelectedItem(null);
            setShow(false);
            GetItems();
          } else {
            toast.warning("Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    } else {
      addItem(payload, {
        onSuccess: (data) => {
          console.log(data);
          if (data) {
            toast.success("Pass Type Added Successfully.");
            setShow(false);
            GetItems();
          } else {
            toast.warning(error.message || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    }
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
      render: (text, record) => <>{text + 1}</>,
    },

    {
      title: "Pass Name",
      dataIndex: "passName",
      sorter: (a, b) => a.passName.length - b.passName.length,
    },

    {
      title: "Skilled Employee",
      dataIndex: "haveSkillUnSkillOption",
      render: (text, record) => (
        <>
          {text === true && <div className="badges badge-linesuccess">Yes</div>}
          {text === false && <div className="badges badge-linedanger">No</div>}
        </>
      ),
    },

    {
      title: "Created User",
      dataIndex: "createUser",
      sorter: (a, b) => a.createUser.length - b.createUser.length,
    },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
            <Can
              accessModule={accessCodes.master}
              accessCode={accessCodes.master_passType}
              accessType="haveEdit"
            >
              <Link
                className="me-2 p-2"
                onClick={() => handleEditClick(record)}
              >
                <Edit className="feather-edit" />
              </Link>
            </Can>
            <Can
              accessModule={accessCodes.master}
              accessCode={accessCodes.master_passType}
              accessType="haveDelete"
            >
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
              >
                <Link className="me-2 p-2" to="#">
                  <Popconfirm
                    title="Are you sure to Delete?"
                    onConfirm={() => deleteItemHandler(record.passCode)}
                  >
                    <Trash2 className="feather-delete" />
                  </Popconfirm>
                </Link>
              </OverlayTrigger>
            </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  useEffect(() => {
    if (isMount) GetItems();

    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Pass Type Management</h4>
                <h6>Manage Compnay Pass Type</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName="Pass Type Master"
                isExcel={true}
                isPdf={true}
                pdfTheme="striped"
                refresh={GetItems}
              />
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.master}
                accessCode={accessCodes.master_passType}
                accessType="haveAdd"
              >
                <Link to="#" className="btn btn-added" onClick={handleAddClick}>
                  <PlusCircle className="me-2" />
                  Add Pass Type
                </Link>
              </Can>
              &nbsp;
              <Link to={`${all_routes.master}`} className="btn btn-secondary">
                <BackIcon className="me-2" />
                Back
              </Link>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={true}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <Switch
                            checked={showActiveOnly}
                            checkedChildren="Show Active"
                            unCheckedChildren="Show All"
                            onChange={(checked) => setShowActiveOnly(checked)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <PassTypeModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default PassType;
